// Translations dictionary
export const translations = {
  pt: {
    // Header
    appTitle: "ResumoPDF",
    appSubtitle: "Resumos inteligentes com IA",
    
    // Upload
    uploadTitle: "Arraste seu PDF aqui",
    uploadSubtitle: "ou clique para selecionar",
    uploadHint: "Arquivos PDF até 50MB",
    
    // Summary types
    summaryTypeTitle: "Tipo de Resumo",
    types: {
      exam: {
        title: "Para Prova",
        description: "Conceitos e definições para estudar"
      },
      executive: {
        title: "Executivo",
        description: "Visão geral e conclusões principais"
      },
      key_points: {
        title: "Pontos-Chave",
        description: "Lista dos pontos mais importantes"
      },
      detailed: {
        title: "Detalhado",
        description: "Resumo completo do documento"
      }
    },
    
    // Actions
    summarize: "Resumir PDF",
    processing: "Processando...",
    download: "Baixar",
    downloadPDF: "Baixar PDF",
    downloadTXT: "Baixar TXT",
    delete: "Excluir",
    copy: "Copiar",
    copied: "Copiado!",
    
    // History
    historyTitle: "Histórico",
    noHistory: "Nenhum resumo ainda",
    
    // Results
    resultTitle: "Resumo",
    resultEmpty: "Seu resumo aparecerá aqui",
    
    // Errors
    errorUpload: "Erro ao fazer upload",
    errorProcess: "Erro ao processar PDF",
    errorDelete: "Erro ao excluir",
    selectFile: "Selecione um arquivo PDF",
    
    // Success
    successDelete: "Resumo excluído",
    successCopy: "Resumo copiado!",
    
    // Loading
    extractingText: "Extraindo texto do PDF...",
    analyzingContent: "Analisando conteúdo...",
    generatingSummary: "Gerando resumo com IA...",
    
    // Footer
    poweredBy: "Created by Miguel Augusto using Groq AI technology."
  },
  en: {
    // Header
    appTitle: "ResumoPDF",
    appSubtitle: "Smart AI-powered summaries",
    
    // Upload
    uploadTitle: "Drag your PDF here",
    uploadSubtitle: "or click to select",
    uploadHint: "PDF files up to 50MB",
    
    // Summary types
    summaryTypeTitle: "Summary Type",
    types: {
      exam: {
        title: "Exam Prep",
        description: "Concepts and definitions to study"
      },
      executive: {
        title: "Executive",
        description: "Overview and main conclusions"
      },
      key_points: {
        title: "Key Points",
        description: "List of most important points"
      },
      detailed: {
        title: "Detailed",
        description: "Complete document summary"
      }
    },
    
    // Actions
    summarize: "Summarize PDF",
    processing: "Processing...",
    download: "Download",
    downloadPDF: "Download PDF",
    downloadTXT: "Download TXT",
    delete: "Delete",
    copy: "Copy",
    copied: "Copied!",
    
    // History
    historyTitle: "History",
    noHistory: "No summaries yet",
    
    // Results
    resultTitle: "Summary",
    resultEmpty: "Your summary will appear here",
    
    // Errors
    errorUpload: "Upload error",
    errorProcess: "Error processing PDF",
    errorDelete: "Error deleting",
    selectFile: "Select a PDF file",
    
    // Success
    successDelete: "Summary deleted",
    successCopy: "Summary copied!",
    
    // Loading
    extractingText: "Extracting text from PDF...",
    analyzingContent: "Analyzing content...",
    generatingSummary: "Generating AI summary...",
    
    // Footer
    poweredBy: "Created by Miguel Augusto using Groq AI technology."
  }
};
